import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_h8vd5c4vfp: FaireBrandEntity = {
  token: "b_h8vd5c4vfp",
  type: "brand",
  name: "Mochi Mob",
  avatarUrl:
    "https://cdn.faire.com/fastly/83569b09d745b0cc23d68cbdaacc04b51b7d150328ff10554b081a4779151318.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e51333bee0b376ce88cbd41f435469e1345acad3100e7fd2d876755a96fe5484.png",
  logoUrl:
    "https://cdn.faire.com/fastly/83569b09d745b0cc23d68cbdaacc04b51b7d150328ff10554b081a4779151318.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e51333bee0b376ce88cbd41f435469e1345acad3100e7fd2d876755a96fe5484.png",
  location: "Laurinburg, NC, USA",
  minimumOrderDollars: 249,
  rating: 1,
  reviewCount: 4,
  isInsider: false,
  description:
    "Founded by Jaiveer Balyan, Buddha Yoga is more than just a brand; it's a mission to bring joy and mindfulness into the lives of children across the USA. Inspired by the teachings of balance and creativity, Buddha Yoga specializes in kids' toys and accessories that not only entertain but also nurture a sense of calm and focus in young minds.\n\nAs a parent or someone who cherishes the joy of children, you understand that play is not just fun—it's a path to learning and growth. At Buddha Yoga, we believe in creating products that spark imagination, foster development, and inspire mindfulness. Our toys and accessories are carefully designed to bring out the best in your little ones, helping them connect with their inner creativity while exploring the world around them.\n\nDriven by a passion to make a difference, Jaiveer Balyan founded Buddha Yoga to blend traditional values with contemporary needs, offering high-quality, innovative products that resonate with both kids and parents. Our collection is crafted with love, ensuring that every product supports a child's journey to happiness, health, and holistic development.\n\nWelcome to Buddha Yoga, where we turn everyday moments into mindful memories, one toy at a time. Join us in spreading joy, laughter, and a little bit of zen to children everywhere.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:43.912Z",
    importedBy: "entity-db-cli",
  },
};
